import { render, staticRenderFns } from "./VacationBalanceDetails.vue?vue&type=template&id=51a491ec&"
import script from "./VacationBalanceDetails.vue?vue&type=script&lang=ts&"
export * from "./VacationBalanceDetails.vue?vue&type=script&lang=ts&"
import style0 from "./VacationBalanceDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports